export default __webpack_public_path__ + "static/firstview-sp-c97360456cf2535359d033262d479ca0.webp";